import { render, staticRenderFns } from "./InsurePayment.vue?vue&type=template&id=24520f36&"
import script from "./InsurePayment.vue?vue&type=script&lang=js&"
export * from "./InsurePayment.vue?vue&type=script&lang=js&"
import style0 from "./InsurePayment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports